<script setup lang="ts">
import { computed, ref, defineProps } from 'vue';
import IconMaterial from '@design_system_v3/components/atoms/IconMaterial.vue';

const props = defineProps({
  size: {
    type: String,
    default: 'md',
    options: ['2xs', 'xs', 'sm', 'md', 'lg', 'xl', '2xl'],
  },
  altText: {
    type: String,
    default: 'Profile Image',
  },
  pathImg: {
    type: String,
    default: '',
  },
  imgHover: {
    type: Boolean,
    default: true,
  },
});
const profileSize = computed(() => {
  switch (props.size) {
    case '2xs':
      return 16;
    case 'xs':
      return 24;
    case 'sm':
      return 32;
    case 'md':
      return 48;
    case 'lg':
      return 56;
    case 'xl':
      return 64;
    case '2xl':
      return 128;
    default:
      return 48;
  }
});

const imgLoadError = ref<boolean>(false);

const handleImgError = () => {
  imgLoadError.value = true;
};
</script>

<template>
  <div
    :class="{
      'img-hover': imgHover,
    }"
    class="profile-wrapper"
    :style="{ height: `${profileSize}px`, width: `${profileSize}px` }"
  >
    <img
      v-if="pathImg && !imgLoadError"
      class="rounded-circle"
      :alt="altText"
      :height="profileSize"
      :width="profileSize"
      :src="pathImg"
      :onerror="handleImgError"
    />
    <IconMaterial v-else icon="person" :size="profileSize" color="#f8fafc" />
  </div>
</template>

<style scoped lang="scss">
@import '@foundation';

.profile-wrapper {
  position: relative;
  display: flex;
  border-radius: 50%;
  background-color: map-get($neutral, 'neutral-200');
}

.profile-wrapper::before {
  content: '';
  position: absolute;
  top: -2px;
  left: -2px;
  width: calc(100% + 4px);
  height: calc(100% + 4px);
  border-radius: 50%;
  border: 2px solid transparent;
  background: linear-gradient(45deg, #4e73df, #692b7e);
  -webkit-mask:
    linear-gradient(#fff 0 0) padding-box,
    linear-gradient(#fff 0 0);
  mask:
    linear-gradient(#fff 0 0) padding-box,
    linear-gradient(#fff 0 0);
  -webkit-mask-composite: destination-out;
  mask-composite: exclude;
  transition: opacity 0.3s ease;
  opacity: 0;
}

.img-hover:hover::before {
  opacity: 1;
}

.rounded-circle {
  border-radius: 50%;
  display: block;
}
</style>
